import { military_base_guide_edit } from "./military_base_guide_edit";

export class military_help_service_edit extends military_base_guide_edit {
    protected getModuleName() {
        return "military_help_service_edit";
    }

    protected isHelpService(): boolean {
        return true;
    }
}



// WEBPACK FOOTER //
// ./js/modules/military_help_service_edit.ts